import "@fortawesome/fontawesome-svg-core/styles.css";

import { Typography } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useRef, useState } from "react";
import "../../src/components/styles.css";
import Version from "../components/version";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./../components/user/whyichest.css";
import Login from "./Login";
import Signup from "./Signup";
import OrganizationSignup from "./OrganizationSignup";

import WelcomeIchest from "./my-estate/welcomeIchest";

import { Homepagenotification } from "../components/alerting-visitors/notification";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  Lock,
  ShieldCheck,
  KeyRound,
  Cloud,
  Clock,
  ClipboardList,
  Users,
  Fingerprint,
  UserCheck,
  EyeOff,
  Eye,
  FileText,
  FileQuestion,
  Boxes,
  ScrollText,
  BadgeCheck,
  MessageSquare,
  Landmark,
  Home as HomeIcon,
  TrendingUp,
  Briefcase,
  Bitcoin,
  HeartPulse,
  PhoneCall,
  Mail,
  Image as ImageIcon,
  Globe,
  Bell,
  Heart,
  CheckCircle2,
  Menu,
  X,
  ChevronDown,
  Facebook,
  Twitter,
  Linkedin,
  Youtube,
  UserPlus,
  Upload,
  CreditCard,
  Activity,
  FileLock2,
  Settings,
  Plus,
} from "lucide-react";

/* ------------------------------------------------------------------ */
/* Small reusable bits                                                 */
/* ------------------------------------------------------------------ */

const IconCircle = ({ children, className = "" }) => (
  <span
    className={`lp-icon-circle ${className}`}
    style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
  >
    {children}
  </span>
);

const SignupChoicePopup = ({ onUserSignup, onOrgSignup, onClose }) => {
  return (
    <div className="signup-choice-overlay">
      <div className="signup-choice-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Select Signup Type</h3>
        <div className="signup-choice-buttons">
          <button className="button btn-solid-lg" onClick={onUserSignup}>
            User Signup
          </button>
          <button className="button btn-solid-lg" onClick={onOrgSignup}>
            Organization Signup
          </button>
        </div>
        <span className="close" onClick={onClose}>
          &times;
        </span>
      </div>
    </div>
  );
};

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800, once: false, easing: "ease-out-cubic" });
  }, []);

  const [showLogin, setShowLogin] = React.useState(false);
  const [showSignin, setShowSignin] = React.useState(false);
  const [showOrgSignup, setShowOrgSignup] = useState(false);
  const [showSignupChoice, setShowSignupChoice] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const partnersRef = useRef(null);
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#aboutus") {
      partnersRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const toggleLogin = () => {
    setShowLogin(!showLogin);
  };

  const handleBack = () => {
    setShowLogin(false);
    setShowSignin(false);
  };

  // Open the signup choice popup instead of the form directly
  const toggleSignin = () => {
    setShowSignupChoice(true);
  };

  // When user clicks User Signup in popup
  const handleUserSignup = () => {
    setShowSignupChoice(false); // close choice popup
    setShowSignin(true); // open existing signup form
  };

  // When user clicks Organization Signup in popup
  const handleOrgSignup = () => {
    setShowSignupChoice(false); // close choice popup
    setShowOrgSignup(true); // show organization signup modal
  };

  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const [isPopupOpen, setPopupOpen] = useState(false);
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  const [modalData, setModalData] = useState(null);

  const profiles = {
    ranjay: {
      title: "R. Kumar",
      role: "President",
      details1:
        "Mr. Kumar is the President of i- chest.com, bringing with him a wealth of experience across multiple domains, including educational leadership, technology, and project management. As the visionary behind the concept of I-Chest.com, he has been instrumental in shaping the platform from its inception. Under his guidance, the platform is being meticulously developed to serve as a comprehensive and secure repository for asset management.",
      details2:
        "Mr. Kumar's entrepreneurial journey is marked by a series of successful ventures, demonstrating his ability to innovate and lead in diverse fields. His background in directing educational institutions, combined with his expertise in technology and project management, has equipped him with the unique skills needed to drive the development of I-Chest.com. With a proven track record of entrepreneurship, Mr. Kumar is dedicated to ensuring that I-Chest becomes a trusted and reliable resource for users seeking to manage their legacies.",
      image: "ranjay.jpeg",
    },
    janice: {
      title: "Janice C. Parker",
      role: "Chairperson Board of Directors",
      details1:
        "Mrs. Parker, in her role with I-Chest.com, collaborates closely with the President to support the marketing efforts of this emerging platform and its unique services, both within the United States and internationally. She is also the President, CEO, and owner of an internationally and culturally diverse associate degree-granting college in Chicago, Illinois.",
      details2:
        "Janice C. Parker Chairperson Board of Directors Mrs. Parker, in her role with I-Chest.com, collaborates closely with the President to support the marketing efforts of this emerging platform and its unique services, both within the United States and internationally. She is also the President, CEO, and owner of an internationally and culturally diverse associate degree-granting college in Chicago, Illinois.",
      image: "parker.png",
    },
    thomas: {
      title: "Thomas Planera",
      role: "Legal Counsellor and Partner",
      details1:
        "Mr. Thomas Planera brings over forty years of experience in legal services to his role as Legal Counsellor and Partner at i-chest.com. As a guiding force behind the platform, Mr. Planera's expertise has been invaluable in shaping its legal framework and strategic direction.",
      details2:
        "Mr.Planera specializes in estate and asset protection planning, corporate and business transactions, including labor issues, and all aspects of commercial and residential real estate development. His firm is also dedicated to advising businesses on the advantages of certifying as a Minority Business Enterprise (MBE) or a Women's Business Enterprise (WBE). In addition to his legal practice, Mr. Planera serves as the president of an educational institution, further demonstrating his leadership and commitment to community and business development.",
      image: "Thomas.png",
    },
    idea: {
      title: "IdeaGenSys",
      role: "Production & Technical Partner",
      details1:
        "Bring about a transformative change and continue striving to make people's lives easier. Embrace the process of development as we endeavour to create a positive impact on the world through cutting-edge IT solutions. Our mission is to provide exceptional services to individuals and institutions globally, and we are committed to fostering a corporate culture that prioritizes people and their needs.",
      details2:
        "We offer a comprehensive range of custom software solutions designed to meet your specific requirements across various domains, including Web, Mobility, AI, IoT, and Block chain development. Our team of highly skilled developers excels in rapid software development, ensuring that we deliver innovative and efficient solutions tailored to your needs. By integrating the latest technologies and maintaining a strong focus on client satisfaction, we aim to drive success and create lasting value for our partners and clients.",
      image: "ideanensys.png",
    },
  };

  const openModal = (profileKey) => {
    setModalData(profiles[profileKey]);
  };

  const closeModal = () => {
    setModalData(null);
  };

  return (
    <>
      <style>{`
.lp-page, .lp-page *, .lp-page *::before, .lp-page *::after{ box-sizing:border-box; }
.lp-page{ font-family:'Segoe UI',-apple-system,BlinkMacSystemFont,Roboto,Helvetica,Arial,sans-serif; color:#1c2a3d; background:#fff; line-height:1.5; }
.lp-page a{ text-decoration:none; color:inherit; }
.lp-page ul{ list-style:none; margin:0; padding:0; }
.lp-page img, .lp-page svg{ display:block; max-width:100%; }
.lp-page button{ font-family:inherit; cursor:pointer; }
.lp-container{ max-width:1180px; margin:0 auto; padding:0 24px; }
.lp-section{ position:relative; }

.lp-btn{ display:inline-flex; align-items:center; justify-content:center; gap:8px; padding:12px 22px; border-radius:8px; font-weight:600; font-size:0.95rem; border:1.5px solid transparent; transition:all .18s ease; white-space:nowrap; }
.lp-btn-primary{ background:#2f6fed; color:#fff; }
.lp-btn-primary:hover{ background:#1e4fc7; transform:translateY(-1px); color:#fff; box-shadow:0 8px 18px rgba(47,111,237,0.28); }
.lp-btn-outline{ background:#fff; border-color:#c9d5e8; color:#0f2a52; }
.lp-btn-outline:hover{ border-color:#2f6fed; color:#2f6fed; transform:translateY(-1px); }
.lp-btn-outline-light{ background:transparent; border-color:rgba(255,255,255,0.5); color:#fff; }
.lp-btn-outline-light:hover{ background:rgba(255,255,255,0.12); color:#fff; transform:translateY(-1px); }
.lp-btn-sm{ padding:9px 16px; font-size:0.85rem; border-radius:7px; }

.lp-header{ position:sticky; top:0; z-index:100; background:rgba(255,255,255,0.94); backdrop-filter:blur(8px); border-bottom:1px solid #e3e9f3; }
.lp-nav-wrap{ display:flex; align-items:center; justify-content:space-between; height:74px; }
.lp-brand{ display:flex; align-items:center; gap:10px; }
.lp-brand-mark{ width:38px; height:38px; border-radius:0; background:transparent; display:flex; align-items:center; justify-content:center; flex-shrink:0; transition:transform .2s ease; }
.lp-brand:hover .lp-brand-mark{ transform:scale(1.06) rotate(-4deg); }
.lp-brand-mark img{ width:100%; height:100%; object-fit:contain; display:block; }
.lp-brand-text{ display:flex; flex-direction:column; line-height:1.2; }
.lp-brand-title{ font-size:1.15rem; color:#0f2a52 !important; font-weight:800 !important; letter-spacing:-0.02em; margin:0 !important; padding:0 !important; display:block; font-family:inherit; }
.lp-brand-sub{ font-size:0.65rem; color:#5b6b82; display:block; margin-top:2px; font-weight:400; }
.lp-nav-links{ display:flex; align-items:center; gap:18px; flex-wrap:nowrap; }
.lp-nav-links a{ font-size:0.86rem; font-weight:600; color:#1c2a3d; position:relative; padding:6px 0; white-space:nowrap; }
.lp-nav-links a::after{ content:""; position:absolute; left:0; right:0; bottom:0; height:2px; background:#2f6fed; border-radius:2px; transform:scaleX(0); transform-origin:left; transition:transform .2s ease; }
.lp-nav-links a:hover{ color:#2f6fed; }
.lp-nav-links a:hover::after{ transform:scaleX(1); }
.lp-nav-link-btn{ font-size:0.86rem; font-weight:600; color:#1c2a3d; background:none; border:none; padding:6px 0; cursor:pointer; font-family:inherit; display:flex; align-items:center; gap:2px; white-space:nowrap; }
.lp-nav-link-btn:hover{ color:#2f6fed; }
.lp-caret-icon{ transition:transform .2s ease; }
.lp-nav-item{ position:relative; }
.lp-nav-item:hover .lp-caret-icon{ transform:rotate(180deg); }
.lp-dropdown{ position:absolute; top:100%; left:50%; transform:translateX(-50%) translateY(4px); min-width:180px; background:#fff; border:1px solid #e3e9f3; border-radius:10px; box-shadow:0 10px 30px rgba(15,42,82,0.12); padding:8px; opacity:0; visibility:hidden; transform-origin:top center; transition:opacity .18s ease, transform .18s ease, visibility .18s ease; z-index:50; }
.lp-nav-item:hover .lp-dropdown{ opacity:1; visibility:visible; transform:translateX(-50%) translateY(0); }
.lp-dropdown a{ display:block; padding:8px 10px; font-size:0.85rem; font-weight:600; color:#1c2a3d; border-radius:6px; }
.lp-dropdown a::after{ display:none; }
.lp-dropdown a:hover{ background:#eaf1fd; color:#2f6fed; }
.lp-nav-actions{ display:flex; align-items:center; gap:12px; }
.lp-menu-toggle{ display:none; background:none; border:none; align-items:center; justify-content:center; }
.lp-mobile-nav{ display:none; }

/* ---- HERO: plain background, image sits in the right-hand column as a
   contained photo block (not a full-bleed background) so it matches the
   target design: ~40% text column / ~60% image column ---- */
.lp-hero{
  position:relative;
  background:#fbfcfe;
  padding:56px 0 70px;
  overflow:visible;
}
.lp-hero .lp-container{ max-width:1420px; }
.lp-hero-grid{ position:relative; z-index:2; display:grid; grid-template-columns:0.85fr 2.3fr; gap:36px; align-items:center; overflow:visible; }
.lp-eyebrow-tag{ display:inline-block; font-size:0.72rem; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; color:#2f6fed; background:#eaf1fd; padding:5px 12px; border-radius:20px; margin-bottom:16px; }
.lp-hero h2{
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-size:2.15rem; line-height:1.18; letter-spacing:-0.01em; color:#0f2a52; font-weight:700; margin:0;
}
.lp-hero h2 .lp-accent{ color:#2f6fed; }
.lp-hero p.lp-lead{ margin-top:18px; font-size:1.02rem; color:#5b6b82; max-width:420px; }

.lp-badge-row{
  display:flex;
  align-items:center;
  gap:22px;
  margin-top:24px;
  flex-wrap:nowrap;
}
.lp-badge-item{
  display:flex;
  align-items:center;
  gap:7px;
  font-size:0.8rem;
  font-weight:600;
  color:#0f2a52;
  white-space:nowrap;
  flex-shrink:0;
}
.lp-badge-item .lp-icon-circle{ width:28px; height:28px; }
.lp-badge-item .lp-icon-circle svg{ width:14px; height:14px; }

.lp-hero-ctas{ display:flex; gap:14px; margin-top:30px; flex-wrap:wrap; }
.lp-hero-note{ display:flex; align-items:center; gap:8px; margin-top:18px; font-size:0.82rem; color:#5b6b82; }
.lp-hero-note svg{ width:16px; height:16px; stroke:#2f6fed; }

/* ---- Hero visual: the family photo is a real, contained image that
   fills the right column (rounded corners + soft shadow), with the
   vault graphic and the floating info card layered on top of it. ---- */
.lp-hero-visual{ position:relative; height:500px; overflow:visible; }

.lp-hero-photo{
  width:100%;
  height:100%;
  object-fit:cover;
  object-position:60% 30%;
  border-radius:18px;
  box-shadow:0 20px 45px rgba(15,42,82,0.18);
  display:block;
}

.lp-vault-overlay{
  position:absolute;
  right:-15px;
  bottom:-18px;
  width:340px;
  height:auto;
  z-index:4;
  object-fit:contain;
  filter:drop-shadow(0 18px 26px rgba(15,42,82,0.4));
}

.lp-float-card{
  position:absolute;
  right:250px;
  bottom:-18px;
  left:auto;
  top:auto;
  transform:none;
  width:300px;
  max-width:72%;
  background:#fff;
  border-radius:14px;
  box-shadow:0 18px 40px rgba(15,42,82,0.18);
  padding:20px 24px;
  z-index:5;
}
.lp-float-card h4{ font-size:1rem; color:#0f2a52; font-weight:800; margin:0; }
.lp-float-card p{ font-size:0.78rem; color:#5b6b82; margin-top:4px; margin-bottom:12px; }
.lp-float-card ul li{ display:flex; align-items:center; gap:8px; font-size:0.8rem; font-weight:600; color:#0f2a52; margin-bottom:7px; }
.lp-float-card ul li:last-child{ margin-bottom:0; }
.lp-float-card ul li svg{ width:15px; height:15px; flex-shrink:0; color:#2fb673; }

@keyframes lpFadeUp{ from{ opacity:0; transform:translateY(14px); } to{ opacity:1; transform:translateY(0); } }

.lp-icon-circle{ width:44px; height:44px; border-radius:50%; background:#eaf1fd; display:flex; align-items:center; justify-content:center; flex-shrink:0; transition:transform .2s ease, background .2s ease; }
.lp-icon-circle svg{ width:20px; height:20px; stroke:#2f6fed; }

.lp-trust-bar{ background:#fbfcfe; padding:46px 0; border-bottom:1px solid #e3e9f3; }
.lp-trust-bar h3{ text-align:center; font-size:1.3rem; color:#0f2a52; font-weight:800; margin:0; }
.lp-trust-bar .lp-sub{ text-align:center; color:#5b6b82; font-size:0.88rem; margin-top:6px; margin-bottom:34px; }
.lp-trust-grid{ display:grid; grid-template-columns:repeat(9,1fr); gap:12px; }
.lp-trust-item{ text-align:center; transition:transform .18s ease; }
.lp-trust-item:hover{ transform:translateY(-3px); }
.lp-trust-item:hover .lp-icon-circle{ background:#dbe7fd; transform:scale(1.08); }
.lp-trust-item .lp-icon-circle{ margin:0 auto 10px; }
.lp-trust-item span{ font-size:0.75rem; font-weight:700; color:#0f2a52; line-height:1.3; display:block; }

.lp-problem-solution{ padding:72px 0; background:#fff; }
.lp-ps-grid{ display:grid; grid-template-columns:1fr 300px 1fr; gap:34px; align-items:start; }
.lp-eyebrow{ font-size:0.78rem; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; color:#2f6fed; margin-bottom:10px; }
.lp-ps-col h3{ font-size:1.55rem; color:#0f2a52; font-weight:800; line-height:1.25; margin-bottom:18px; margin-top:0; }
.lp-stat-row{ display:flex; gap:14px; margin-top:6px; }
.lp-stat-card{ flex:1; background:#f4f8fd; border:1px solid #e3e9f3; border-radius:12px; padding:18px 14px; text-align:center; transition:all .18s ease; }
.lp-stat-card:hover{ border-color:#2f6fed; transform:translateY(-2px); box-shadow:0 6px 16px rgba(15,42,82,0.06); }
.lp-stat-card .lp-icon-circle{ margin:0 auto 10px; width:36px; height:36px; }
.lp-stat-card .lp-icon-circle svg{ width:16px; height:16px; }
.lp-stat-card .lp-num{ font-size:1.5rem; font-weight:800; color:#2f6fed; }
.lp-stat-card p{ font-size:0.74rem; color:#5b6b82; margin-top:6px; line-height:1.35; }
.lp-ps-tagline{ margin-top:22px; font-weight:700; color:#2f6fed; font-size:0.95rem; text-decoration:underline; text-underline-offset:4px; }
.lp-ps-col p.lp-desc{ color:#5b6b82; font-size:0.92rem; margin-bottom:20px; }
.lp-solution-grid{ display:grid; grid-template-columns:1fr 1fr; gap:12px; }
.lp-solution-item{ display:flex; align-items:center; gap:10px; border:1px solid #e3e9f3; border-radius:10px; padding:12px 14px; font-size:0.82rem; font-weight:700; color:#0f2a52; transition:all .18s ease; }
.lp-solution-item:hover{ border-color:#2f6fed; background:#f7faff; transform:translateY(-2px); }
.lp-solution-item .lp-icon-circle{ width:32px; height:32px; }
.lp-solution-item .lp-icon-circle svg{ width:15px; height:15px; }
.lp-learn-more{ display:inline-flex; align-items:center; gap:4px; margin-top:20px; font-weight:700; color:#2f6fed; font-size:0.88rem; transition:gap .18s ease; }
.lp-learn-more:hover{ gap:8px; }

.lp-phone{ width:260px; margin:0 auto; background:#111c2e; border-radius:34px; padding:10px; box-shadow:0 10px 30px rgba(15,42,82,0.08); }
.lp-phone-screen{ background:#eaf1fd; border-radius:26px; overflow:hidden; }
.lp-phone-status{ display:flex; justify-content:space-between; align-items:center; padding:10px 16px 4px; font-size:0.65rem; font-weight:700; color:#0f2a52; }
.lp-phone-header{ background:linear-gradient(135deg,#2f6fed,#0f2a52); color:#fff; padding:14px 16px 18px; }
.lp-phone-header .lp-tag{ font-size:0.62rem; opacity:0.8; margin-bottom:2px; }
.lp-phone-header h5{ font-size:0.95rem; font-weight:800; margin:0; }
.lp-phone-list{ padding:12px; display:flex; flex-direction:column; gap:8px; }
.lp-phone-row{ display:flex; align-items:center; gap:10px; background:#fff; border-radius:10px; padding:9px 10px; box-shadow:0 2px 6px rgba(15,42,82,0.06); }
.lp-phone-row .lp-ic{ width:26px; height:26px; border-radius:7px; background:#eaf1fd; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.lp-phone-row .lp-ic svg{ width:13px; height:13px; stroke:#2f6fed; }
.lp-phone-row .lp-txt strong{ display:block; font-size:0.7rem; color:#0f2a52; }
.lp-phone-row .lp-txt span{ font-size:0.6rem; color:#5b6b82; }
.lp-phone-nav{ display:flex; justify-content:space-around; align-items:center; padding:10px 8px 14px; }
.lp-phone-nav .lp-dot{ width:22px; height:22px; opacity:0.35; }
.lp-phone-nav .lp-dot svg{ stroke:#2f6fed; }
.lp-phone-nav .lp-dot.lp-active{ width:34px; height:34px; opacity:1; background:#2f6fed; border-radius:50%; display:flex; align-items:center; justify-content:center; }
.lp-phone-nav .lp-dot.lp-active svg{ stroke:#fff; width:15px; height:15px; }

.lp-how-it-works{ background:#f4f8fd; padding:70px 0; }
.lp-how-it-works h3{ text-align:center; font-size:1.7rem; color:#0f2a52; font-weight:800; margin:0; }
.lp-how-it-works .lp-sub{ text-align:center; color:#5b6b82; margin-top:8px; margin-bottom:46px; font-size:0.92rem; }
.lp-steps{ display:grid; grid-template-columns:repeat(5,1fr); gap:18px; position:relative; }
.lp-steps::before{
  content:"";
  position:absolute;
  top:26px;
  left:calc(10% + 26px);
  right:calc(10% + 26px);
  border-top:2px dashed #aac3f2;
  z-index:0;
}
.lp-step{ position:relative; z-index:1; text-align:center; }
.lp-step-badge{ position:relative; z-index:1; width:52px; height:52px; border-radius:50%; margin:0 auto 16px; background:#2f6fed; display:flex; align-items:center; justify-content:center; box-shadow:0 8px 18px rgba(47,111,237,0.35); transition:transform .2s ease; }
.lp-step:hover .lp-step-badge{ transform:scale(1.1); }
.lp-step-badge svg{ width:22px; height:22px; stroke:#fff; }
.lp-step .lp-step-label{ font-size:0.7rem; font-weight:700; color:#2f6fed; text-transform:uppercase; letter-spacing:0.05em; margin-bottom:6px; }
.lp-step h5{ font-size:0.95rem; color:#0f2a52; font-weight:800; margin-bottom:8px; margin-top:0; line-height:1.3; }
.lp-step p{ font-size:0.78rem; color:#5b6b82; line-height:1.4; padding:0 6px; margin:0; }

.lp-feature-section{ padding:72px 0; }
.lp-feature-section > .lp-container > h3{ text-align:center; font-size:1.7rem; color:#0f2a52; font-weight:800; margin-bottom:38px; margin-top:0; }
.lp-feature-layout{ display:grid; grid-template-columns:1fr 280px; gap:26px; align-items:start; }
.lp-feature-grid{ display:grid; grid-template-columns:repeat(6,1fr); gap:12px; }
.lp-feature-tile{ border:1px solid #e3e9f3; border-radius:12px; padding:18px 10px; text-align:center; transition:all .18s ease; }
.lp-feature-tile:hover{ border-color:#2f6fed; box-shadow:0 4px 14px rgba(15,42,82,0.06); transform:translateY(-2px); }
.lp-feature-tile:hover .lp-icon-circle{ background:#dbe7fd; transform:scale(1.08); }
.lp-feature-tile .lp-icon-circle{ margin:0 auto 10px; width:38px; height:38px; }
.lp-feature-tile .lp-icon-circle svg{ width:17px; height:17px; }
.lp-feature-tile span{ font-size:0.74rem; font-weight:700; color:#0f2a52; line-height:1.3; }
.lp-control-card{ background:#eaf1fd; border-radius:14px; padding:26px 22px; text-align:center; height:100%; display:flex; flex-direction:column; align-items:center; justify-content:center; }
.lp-control-card .lp-icon-circle{ width:52px; height:52px; margin-bottom:16px; background:#fff; }
.lp-control-card .lp-icon-circle svg{ width:24px; height:24px; }
.lp-control-card h4{ font-size:1.15rem; color:#0f2a52; font-weight:800; margin-bottom:10px; margin-top:0; }
.lp-control-card p{ font-size:0.83rem; color:#5b6b82; margin-bottom:14px; }
.lp-control-card a{ font-weight:700; color:#2f6fed; font-size:0.85rem; }

.lp-why-section{ padding:0 0 72px; }
.lp-why-section h3{ text-align:center; font-size:1.5rem; color:#0f2a52; font-weight:800; margin-bottom:34px; margin-top:0; }
.lp-why-grid{ display:grid; grid-template-columns:repeat(6,1fr); gap:14px; }
.lp-why-item{ border:1px solid #e3e9f3; border-radius:12px; padding:22px 14px; text-align:center; transition:all .18s ease; }
.lp-why-item:hover{ border-color:#2f6fed; box-shadow:0 4px 14px rgba(15,42,82,0.06); transform:translateY(-2px); }
.lp-why-item:hover .lp-icon-circle{ background:#dbe7fd; transform:scale(1.08); }
.lp-why-item .lp-icon-circle{ margin:0 auto 12px; }
.lp-why-item span{ font-size:0.78rem; font-weight:700; color:#0f2a52; }

.lp-security-section{ background:linear-gradient(120deg,#0e2549 0%,#123268 60%,#16407f 100%); padding:60px 0; color:#fff; }
.lp-security-grid{ display:grid; grid-template-columns:220px 1fr 300px; gap:40px; align-items:center; }
.lp-shield-emblem{ position:relative; width:260px; height:260px; margin:0 auto; display:flex; align-items:center; justify-content:center; }
.lp-shield-emblem .lp-glow{ position:absolute; inset:-20px; border-radius:50%; background:radial-gradient(circle,rgba(80,140,255,0.5),transparent 70%); }
.lp-shield-img{ position:relative; width:300px; height:auto; z-index:1; filter:drop-shadow(0 12px 24px rgba(15,42,82,0.35)); }
.lp-security-copy h4{ font-size:1.5rem; font-weight:800; margin-bottom:12px; margin-top:0; }
.lp-security-copy > p{ color:#c7d6ef; font-size:0.9rem; margin-bottom:20px; max-width:460px; }
.lp-sec-list{ display:grid; grid-template-columns:1fr 1fr; gap:10px 24px; }
.lp-sec-list li{ display:flex; align-items:center; gap:8px; font-size:0.83rem; font-weight:600; }
.lp-sec-list li svg{ width:15px; height:15px; stroke:#6ee7b7; flex-shrink:0; }
.lp-sec-stats{ display:grid; grid-template-columns:1fr 1fr; gap:12px; }
.lp-sec-stat{ background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:12px; padding:16px; text-align:center; transition:all .18s ease; }
.lp-sec-stat:hover{ background:rgba(255,255,255,0.14); transform:translateY(-2px); }
.lp-sec-stat .lp-icon-circle{ background:rgba(255,255,255,0.14); margin:0 auto 8px; width:34px; height:34px; }
.lp-sec-stat .lp-icon-circle svg{ stroke:#fff; width:16px; height:16px; }
.lp-sec-stat .lp-num{ font-size:1.15rem; font-weight:800; }
.lp-sec-stat .lp-lbl{ font-size:0.7rem; color:#c7d6ef; margin-top:2px; }

.lp-testimonials{ padding:68px 0; background:#fbfcfe; }
.lp-testimonials h3{ text-align:center; font-size:1.5rem; font-weight:800; color:#0f2a52; margin-bottom:40px; margin-top:0; }
.lp-testi-grid{ display:grid; grid-template-columns:repeat(3,1fr); gap:18px; }
.lp-testi-card{ background:#fff; border:1px solid #e3e9f3; border-radius:14px; padding:24px 22px; transition:all .18s ease; }
.lp-testi-card:hover{ transform:translateY(-3px); box-shadow:0 12px 26px rgba(15,42,82,0.08); border-color:#dbe7fd; }
.lp-testi-card .lp-stars{ color:#f5b400; letter-spacing:2px; margin-bottom:10px; }
.lp-testi-card .lp-quote{ font-size:0.9rem; color:#1c2a3d; line-height:1.5; margin-bottom:16px; min-height:70px; }
.lp-testi-card .lp-avatar{ width:34px; height:34px; border-radius:50%; background:#2f6fed; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; margin-bottom:8px; }
.lp-testi-card .lp-name{ font-weight:700; color:#0f2a52; font-size:0.85rem; }
.lp-testi-card .lp-role{ font-size:0.78rem; color:#5b6b82; }

.lp-cta-banner{ background:linear-gradient(120deg,#0e2549,#1e4fc7); padding:56px 0; color:#fff; }
.lp-cta-banner-grid{ display:flex; align-items:center; justify-content:space-between; gap:30px; flex-wrap:wrap; }
.lp-cta-banner-grid h3{ font-size:1.6rem; font-weight:800; margin:0 0 10px; }
.lp-cta-banner-grid p{ color:#c7d6ef; font-size:0.92rem; max-width:480px; margin:0; }
.lp-cta-banner-actions{ display:flex; gap:14px; flex-wrap:wrap; }
.lp-cta-banner-img{ width:450px; max-width:40%; height:auto; border-radius:14px; flex-shrink:0; }

.lp-footer{ background:#0e2038; color:#c7d6ef; padding-top:56px; }
.lp-footer-top{ display:grid; grid-template-columns:1.6fr repeat(5,1fr); gap:28px; padding-bottom:36px; border-bottom:1px solid rgba(255,255,255,0.08); }
.lp-footer-brand .lp-brand-title{ color:#fff !important; }
.lp-footer-brand .lp-brand-sub{ color:#9fb2d4; }
.lp-footer-social{ display:flex; gap:10px; margin-top:16px; }
.lp-footer-social a{ width:32px; height:32px; border-radius:8px; background:rgba(255,255,255,0.08); display:flex; align-items:center; justify-content:center; transition:all .18s ease; }
.lp-footer-social a:hover{ background:#2f6fed; transform:translateY(-2px); }
.lp-footer-col h6{ font-size:0.85rem; color:#fff; font-weight:700; margin-bottom:14px; margin-top:0; }
.lp-footer-col ul li{ margin-bottom:10px; font-size:0.82rem; }
.lp-footer-col ul li a::after{ display:none; }
.lp-footer-col ul li a:hover{ color:#fff; }
.lp-footer-badges{ display:grid; grid-template-columns:repeat(4,1fr); gap:8px; align-content:start; margin-top:14px; }
.lp-fbadge{ border:1px solid rgba(255,255,255,0.18); border-radius:8px; padding:8px 6px; text-align:center; font-size:0.6rem; font-weight:700; transition:all .18s ease; }
.lp-fbadge:hover{ border-color:rgba(255,255,255,0.4); transform:translateY(-2px); }
.lp-fbadge .lp-icon-circle{ width:26px; height:26px; background:rgba(255,255,255,0.1); margin:0 auto 4px; }
.lp-fbadge .lp-icon-circle svg{ width:12px; height:12px; stroke:#9fd6ff; }
.lp-footer-bottom{ display:flex; justify-content:space-between; align-items:center; padding:18px 0; font-size:0.78rem; color:#9fb2d4; flex-wrap:wrap; gap:10px; }
.lp-footer-bottom-links{ display:flex; gap:18px; }
.lp-footer-bottom-links a::after{ display:none; }
.lp-footer-bottom-links a:hover{ color:#fff; }

@media (max-width: 1140px){
  .lp-nav-links{ display:none; }
  .lp-menu-toggle{ display:flex; background:none; border:none; }
  .lp-mobile-nav{ display:flex; flex-direction:column; gap:14px; padding:16px 24px 20px; background:#fff; border-bottom:1px solid #e3e9f3; }
  .lp-hero-grid{ grid-template-columns:1fr; }
  .lp-hero-visual{ height:340px; order:-1; margin-bottom:40px; }
  .lp-vault-overlay{ width:230px; right:-8px; bottom:-14px; }
  .lp-float-card{ width:220px; right:170px; }
  .lp-trust-grid{ grid-template-columns:repeat(3,1fr); }
  .lp-ps-grid{ grid-template-columns:1fr; }
  .lp-steps{ grid-template-columns:repeat(2,1fr); row-gap:34px; }
  .lp-steps::before{ display:none; }
  .lp-feature-layout{ grid-template-columns:1fr; }
  .lp-feature-grid{ grid-template-columns:repeat(3,1fr); }
  .lp-why-grid{ grid-template-columns:repeat(3,1fr); }
  .lp-security-grid{ grid-template-columns:1fr; text-align:center; }
  .lp-sec-list{ grid-template-columns:1fr 1fr; justify-content:center; }
  .lp-testi-grid{ grid-template-columns:1fr; }
  .lp-footer-top{ grid-template-columns:repeat(2,1fr); }
}
@media (max-width: 640px){
  .lp-badge-row{ flex-wrap:wrap; gap:14px 20px; }
}
@media (max-width: 560px){
  .lp-hero h2{ font-size:2rem; }
  .lp-hero-visual{ height:280px; }
  .lp-vault-overlay{ width:160px; right:-4px; bottom:-8px; }
  .lp-float-card{ position:static; width:100%; max-width:100%; margin-top:14px; right:auto; bottom:auto; transform:none; }
  .lp-trust-grid{ grid-template-columns:repeat(2,1fr); }
  .lp-feature-grid{ grid-template-columns:repeat(2,1fr); }
  .lp-why-grid{ grid-template-columns:repeat(2,1fr); }
  .lp-cta-banner-grid{ justify-content:center; text-align:center; }
  .lp-cta-banner-img{ max-width:60%; margin:0 auto; }
  .lp-footer-top{ grid-template-columns:1fr 1fr; }
}
      `}</style>

      <div className="lp-page">
        {showPopup && <WelcomeIchest closePopup={closePopup} />}

        {!showPopup && (
          <div>
            {/* ============ HEADER ============ */}
            <header className="lp-header">
              <div className="lp-container lp-nav-wrap">
                <a href="#header" className="lp-brand">
                  <span
                    className="lp-brand-mark"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src="/img/i-chestLogo.png" alt="I-Chest logo" />
                  </span>
                  <span className="lp-brand-text">
                    <span className="lp-brand-title">
                      I<span style={{ color: "#2f6fed" }}>-</span>Chest
                    </span>
                    <span className="lp-brand-sub">
                      Secure Your Legacy. Empower the Future.
                    </span>
                  </span>
                </a>

                <nav className="lp-nav-links">
                  <a href="#header">Home</a>
                  <a href="#features">Features</a>
                  <a href="#how-it-works">How It Works</a>
                  <div className="lp-nav-item">
                    <button type="button" className="lp-nav-link-btn">
                      Solutions{" "}
                      <ChevronDown size={14} className="lp-caret-icon" />
                    </button>
                    <div className="lp-dropdown">
                      <a href="#features" onClick={toggleSignin}>
                        For Individuals
                      </a>
                      <a href="#features" onClick={toggleSignin}>
                        For Families
                      </a>
                      <a href="#features" onClick={toggleSignin}>
                        For Advisors
                      </a>
                      <a href="#features" onClick={toggleSignin}>
                        For Businesses
                      </a>
                    </div>
                  </div>
                  <div className="lp-nav-item">
                    <button type="button" className="lp-nav-link-btn">
                      Resources{" "}
                      <ChevronDown size={14} className="lp-caret-icon" />
                    </button>
                    <div className="lp-dropdown">
                      <Link to="/contact-us">Help Center</Link>
                      <a href="#header">Guides</a>
                      <a href="#header">FAQ</a>
                      <Link to="/contact-us">Contact Us</Link>
                    </div>
                  </div>
                  <a href="#header">About Us</a>
                  <Link to="/employee">Employee</Link>
                </nav>

                <div className="lp-nav-actions">
                  <button
                    className="lp-btn lp-btn-primary lp-btn-sm"
                    onClick={toggleSignin}
                  >
                    Get Started Free
                  </button>
                  <button
                    className="lp-btn lp-btn-outline lp-btn-sm"
                    onClick={toggleLogin}
                  >
                    Login
                  </button>
                </div>

                <button
                  className="lp-menu-toggle"
                  aria-label="Toggle menu"
                  onClick={() => setMobileNavOpen(!mobileNavOpen)}
                >
                  {mobileNavOpen ? (
                    <X size={24} color="#0f2a52" strokeWidth={2} />
                  ) : (
                    <Menu size={24} color="#0f2a52" strokeWidth={2} />
                  )}
                </button>
              </div>

              {mobileNavOpen && (
                <div className="lp-mobile-nav">
                  <a href="#header" onClick={() => setMobileNavOpen(false)}>
                    Home
                  </a>
                  <a href="#features" onClick={() => setMobileNavOpen(false)}>
                    Features
                  </a>
                  <a
                    href="#how-it-works"
                    onClick={() => setMobileNavOpen(false)}
                  >
                    How It Works
                  </a>
                  <a href="#header" onClick={() => setMobileNavOpen(false)}>
                    About Us
                  </a>
                  <Link
                    to="/contact-us"
                    onClick={() => setMobileNavOpen(false)}
                  >
                    Contact Us
                  </Link>
                  <Link to="/employee" onClick={() => setMobileNavOpen(false)}>
                    Employee
                  </Link>
                  <button
                    className="lp-btn lp-btn-primary lp-btn-sm"
                    onClick={() => {
                      setMobileNavOpen(false);
                      toggleSignin();
                    }}
                  >
                    Get Started Free
                  </button>
                  <button
                    className="lp-btn lp-btn-outline lp-btn-sm"
                    onClick={() => {
                      setMobileNavOpen(false);
                      toggleLogin();
                    }}
                  >
                    Login
                  </button>
                </div>
              )}
            </header>

            {/* ============ MODALS ============ */}
            {showLogin && (
              <div
                className="login-popup"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-delay="50"
                data-aos-duration="1000"
              >
                <div className="login-content">
                  {showLogin && <Login onBack={handleBack} />}
                </div>
              </div>
            )}

            {showSignupChoice && (
              <SignupChoicePopup
                onUserSignup={handleUserSignup}
                onOrgSignup={handleOrgSignup}
                onClose={() => setShowSignupChoice(false)}
              />
            )}

            {showOrgSignup && (
              <OrganizationSignup onClose={() => setShowOrgSignup(false)} />
            )}

            {showSignin && (
              <div
                className="login-popup"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-delay="50"
                data-aos-duration="1000"
              >
                <div className="login-content">
                  {showSignin && <Signup onBack={handleBack} />}
                </div>
              </div>
            )}

            <div
              style={{
                position: "sticky",
                top: "74px",
                zIndex: 999,
                width: "100%",
              }}
            >
              <Homepagenotification />
            </div>

            {/* ============ HERO ============ */}
            <section id="header" className="lp-section lp-hero">
              <div className="lp-container lp-hero-grid">
                <div className="lp-hero-copy" data-aos="fade-right">
                  <span className="lp-eyebrow-tag">Digital Legacy Vault</span>
                  <h2>
                    Protect Everything You've Built.
                    <br />
                    <span className="lp-accent">
                      Ensure Your Legacy Lives On.
                    </span>
                  </h2>
                  <p className="lp-lead">
                    I-Chest is your secure digital legacy vault for life's most
                    important documents, assets, and future planning. Organized,
                    protected, and shared with the right people, at the right
                    time.
                  </p>

                  <div className="lp-badge-row">
                    <div className="lp-badge-item">
                      <IconCircle>
                        <ShieldCheck size={14} />
                      </IconCircle>
                      Bank-Grade Security
                    </div>
                    <div className="lp-badge-item">
                      <IconCircle>
                        <Lock size={14} />
                      </IconCircle>
                      Encrypted Vault
                    </div>
                    <div className="lp-badge-item">
                      <IconCircle>
                        <UserCheck size={14} />
                      </IconCircle>
                      Trusted Access
                    </div>
                    <div className="lp-badge-item">
                      <IconCircle>
                        <EyeOff size={14} />
                      </IconCircle>
                      Privacy First
                    </div>
                  </div>

                  <div className="lp-hero-ctas">
                    <button
                      className="lp-btn lp-btn-primary"
                      onClick={toggleSignin}
                    >
                      Start Your Secure Vault
                    </button>
                    <Link to="/contact-us" className="lp-btn lp-btn-outline">
                      Book a Demo
                    </Link>
                  </div>

                  <div className="lp-hero-note">
                    <CheckCircle2 size={16} color="#2f6fed" />
                    Private Beta&nbsp;•&nbsp;Invitation Only
                  </div>
                </div>

                <div className="lp-hero-visual" data-aos="fade-left">
                  <img
                    src="/img/hero.png"
                    alt="Family looking out over the water together"
                    className="lp-hero-photo"
                  />

                  <img
                    src="/img/vault.png"
                    alt="Secure digital vault"
                    className="lp-vault-overlay"
                  />

                  <div className="lp-float-card">
                    <h4>Your Legacy. Secured.</h4>
                    <p>Giving your loved ones clarity, not confusion.</p>
                    <ul>
                      <li>
                        <CheckCircle2 size={15} color="#2fb673" />
                        Secure Digital Vault
                      </li>
                      <li>
                        <CheckCircle2 size={15} color="#2fb673" />
                        Legacy Planning
                      </li>
                      <li>
                        <CheckCircle2 size={15} color="#2fb673" />
                        Executor Verification
                      </li>
                      <li>
                        <CheckCircle2 size={15} color="#2fb673" />
                        Beneficiary Access
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* ============ TRUST BAR ============ */}
            <section className="lp-section lp-trust-bar">
              <div className="lp-container">
                <h3 data-aos="fade-up">Trusted to Protect What Matters Most</h3>
                <p className="lp-sub" data-aos="fade-up">
                  Enterprise-grade security for your family's most valuable
                  information.
                </p>
                <div className="lp-trust-grid">
                  {[
                    { label: "AES-256 Encryption", icon: <Lock size={20} /> },
                    {
                      label: "Zero Knowledge Architecture",
                      icon: <Fingerprint size={20} />,
                    },
                    {
                      label: "Multi-Factor Authentication",
                      icon: <KeyRound size={20} />,
                    },
                    { label: "GDPR Ready", icon: <ShieldCheck size={20} /> },
                    {
                      label: "CCPA/CPRA Compliant",
                      icon: <ShieldCheck size={20} />,
                    },
                    {
                      label: "Encrypted Cloud Storage",
                      icon: <Cloud size={20} />,
                    },
                    { label: "99.99% Availability", icon: <Clock size={20} /> },
                    {
                      label: "Audit Logs & Monitoring",
                      icon: <ClipboardList size={20} />,
                    },
                    { label: "Role-Based Access", icon: <Users size={20} /> },
                  ].map((t, i) => (
                    <div
                      className="lp-trust-item"
                      key={i}
                      data-aos="fade-up"
                      data-aos-delay={i * 50}
                    >
                      <IconCircle>{t.icon}</IconCircle>
                      <span>{t.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ============ PROBLEM / SOLUTION ============ */}
            <section className="lp-section lp-problem-solution" id="features">
              <div className="lp-container lp-ps-grid">
                <div className="lp-ps-col" data-aos="fade-right">
                  <div className="lp-eyebrow">The Problem</div>
                  <h3>Too Many Families Lose What Matters Most</h3>
                  <div className="lp-stat-row">
                    <div className="lp-stat-card">
                      <IconCircle>
                        <FileText size={16} />
                      </IconCircle>
                      <div className="lp-num">70%</div>
                      <p>Families struggle locating important documents.</p>
                    </div>
                    <div className="lp-stat-card">
                      <IconCircle>
                        <FileQuestion size={16} />
                      </IconCircle>
                      <div className="lp-num">40%</div>
                      <p>Digital assets are never claimed.</p>
                    </div>
                    <div className="lp-stat-card">
                      <IconCircle>
                        <Users size={16} />
                      </IconCircle>
                      <div className="lp-num">Millions</div>
                      <p>
                        In wealth remains inaccessible because heirs don't know
                        it exists.
                      </p>
                    </div>
                  </div>
                  <div className="lp-ps-tagline">I-Chest changes that.</div>
                </div>

                <div className="lp-phone" data-aos="fade-up">
                  <div className="lp-phone-screen">
                    <div className="lp-phone-status">
                      <span>9:41</span>
                      <span>●●●</span>
                    </div>
                    <div className="lp-phone-header">
                      <div className="lp-tag">Welcome to</div>
                      <h5>Your Legacy Vault</h5>
                    </div>
                    <div className="lp-phone-list">
                      {[
                        {
                          icon: <FileText size={13} />,
                          title: "My Documents",
                          sub: "24 items",
                        },
                        {
                          icon: <Landmark size={13} />,
                          title: "Financial Assets",
                          sub: "8 accounts",
                        },
                        {
                          icon: <HomeIcon size={13} />,
                          title: "Properties",
                          sub: "3 properties",
                        },
                        {
                          icon: <ShieldCheck size={13} />,
                          title: "Insurance",
                          sub: "5 policies",
                        },
                        {
                          icon: <Boxes size={13} />,
                          title: "Digital Assets",
                          sub: "12 items",
                        },
                        {
                          icon: <Users size={13} />,
                          title: "Family & Executors",
                          sub: "4 contacts",
                        },
                      ].map((row, i) => (
                        <div className="lp-phone-row" key={i}>
                          <span
                            className="lp-ic"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {row.icon}
                          </span>
                          <span className="lp-txt">
                            <strong>{row.title}</strong>
                            <span>{row.sub}</span>
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="lp-phone-nav">
                      <span
                        className="lp-dot"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <HomeIcon size={13} />
                      </span>
                      <span
                        className="lp-dot"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FileText size={13} />
                      </span>
                      <span
                        className="lp-dot lp-active"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Plus size={15} />
                      </span>
                      <span
                        className="lp-dot"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Users size={13} />
                      </span>
                      <span
                        className="lp-dot"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Settings size={13} />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="lp-ps-col" data-aos="fade-left">
                  <div className="lp-eyebrow">The Solution</div>
                  <h3>Your Complete Digital Legacy Platform</h3>
                  <p className="lp-desc">
                    I-Chest helps you organize, protect, and pass on your legacy
                    with confidence.
                  </p>
                  <div className="lp-solution-grid">
                    {[
                      {
                        icon: <FileLock2 size={15} />,
                        label: "Secure Document Vault",
                      },
                      {
                        icon: <Boxes size={15} />,
                        label: "Digital Asset Management",
                      },
                      {
                        icon: <ScrollText size={15} />,
                        label: "Legacy & Estate Planning",
                      },
                      {
                        icon: <Users size={15} />,
                        label: "Trusted Beneficiaries",
                      },
                      {
                        icon: <BadgeCheck size={15} />,
                        label: "Executor Verification",
                      },
                      {
                        icon: <MessageSquare size={15} />,
                        label: "Private Family Messages",
                      },
                    ].map((s, i) => (
                      <div className="lp-solution-item" key={i}>
                        <IconCircle>{s.icon}</IconCircle>
                        {s.label}
                      </div>
                    ))}
                  </div>
                  <Link to="/WhyI-chest#integral" className="lp-learn-more">
                    Learn More →
                  </Link>
                </div>
              </div>
            </section>

            {/* ============ HOW IT WORKS ============ */}
            <section className="lp-section lp-how-it-works" id="how-it-works">
              <div className="lp-container">
                <h3 data-aos="fade-up">How I-Chest Works</h3>
                <p className="lp-sub" data-aos="fade-up">
                  Simple steps today. Peace of mind for generations.
                </p>
                <div className="lp-steps">
                  {[
                    {
                      icon: <UserPlus size={22} color="#fff" />,
                      label: "Step 1",
                      title: "Create Your Secure Vault",
                      desc: "Sign up and set up your encrypted vault in minutes.",
                    },
                    {
                      icon: <Upload size={22} color="#fff" />,
                      label: "Step 2",
                      title: "Upload & Organize Your Assets",
                      desc: "Store all important documents, accounts, and digital assets.",
                    },
                    {
                      icon: <Users size={22} color="#fff" />,
                      label: "Step 3",
                      title: "Add Beneficiaries & Trusted Contacts",
                      desc: "Choose who can access your information.",
                    },
                    {
                      icon: <ShieldCheck size={22} color="#fff" />,
                      label: "Step 4",
                      title: "Assign Executor & Set Rules",
                      desc: "Define access conditions and verification steps.",
                    },
                    {
                      icon: <CheckCircle2 size={22} color="#fff" />,
                      label: "Step 5",
                      title: "Relax. Your Legacy Is Protected.",
                      desc: "Your loved ones will have what they need, when they need it.",
                    },
                  ].map((s, i) => (
                    <div
                      className="lp-step"
                      key={i}
                      data-aos="fade-up"
                      data-aos-delay={i * 80}
                    >
                      <div className="lp-step-badge">{s.icon}</div>
                      <div className="lp-step-label">{s.label}</div>
                      <h5>{s.title}</h5>
                      <p>{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ============ EVERYTHING YOU NEED ============ */}
            <section className="lp-section lp-feature-section">
              <div className="lp-container">
                <h3 data-aos="fade-up">
                  Everything You Need. All in One Place.
                </h3>
                <div className="lp-feature-layout">
                  <div className="lp-feature-grid">
                    {[
                      {
                        icon: <FileLock2 size={17} />,
                        label: "Secure Document Vault",
                      },
                      {
                        icon: <CreditCard size={17} />,
                        label: "Bank Accounts & Cards",
                      },
                      {
                        icon: <TrendingUp size={17} />,
                        label: "Investments & Stocks",
                      },
                      {
                        icon: <HomeIcon size={17} />,
                        label: "Real Estate & Properties",
                      },
                      {
                        icon: <Briefcase size={17} />,
                        label: "Business Ownership",
                      },
                      {
                        icon: <Bitcoin size={17} />,
                        label: "Crypto Assets & Wallets",
                      },
                      {
                        icon: <ShieldCheck size={17} />,
                        label: "Insurance Records",
                      },
                      {
                        icon: <ScrollText size={17} />,
                        label: "Wills & Trusts",
                      },
                      {
                        icon: <FileText size={17} />,
                        label: "Legal Documents",
                      },
                      {
                        icon: <HeartPulse size={17} />,
                        label: "Medical Directives",
                      },
                      {
                        icon: <PhoneCall size={17} />,
                        label: "Emergency Contacts",
                      },
                      {
                        icon: <Mail size={17} />,
                        label: "Personal Letters & Messages",
                      },
                      {
                        icon: <ImageIcon size={17} />,
                        label: "Photos & Videos",
                      },
                      {
                        icon: <KeyRound size={17} />,
                        label: "Password Manager",
                      },
                    ].map((f, i) => (
                      <div
                        className="lp-feature-tile"
                        key={i}
                        data-aos="fade-up"
                        data-aos-delay={(i % 6) * 50}
                      >
                        <IconCircle>{f.icon}</IconCircle>
                        <span>{f.label}</span>
                      </div>
                    ))}
                  </div>
                  <div className="lp-control-card" data-aos="fade-left">
                    <IconCircle>
                      <ShieldCheck size={24} color="#2f6fed" />
                    </IconCircle>
                    <h4>Your Legacy. Your Control.</h4>
                    <p>
                      You decide what to store, who can access, and when. Always
                      in your control.
                    </p>
                    <Link to="/WhyI-chest#integral">
                      Explore All Features →
                    </Link>
                  </div>
                </div>
              </div>
            </section>

            {/* ============ WHY FAMILIES LOVE ============ */}
            <section className="lp-section lp-why-section">
              <div className="lp-container">
                <h3 data-aos="fade-up">Why Families Love I-Chest</h3>
                <div className="lp-why-grid">
                  {[
                    {
                      icon: <Lock size={20} />,
                      label: "End-to-End Encryption",
                    },
                    { icon: <EyeOff size={20} />, label: "Privacy First" },
                    { icon: <UserCheck size={20} />, label: "Trusted Access" },
                    { icon: <Globe size={20} />, label: "Global Access" },
                    { icon: <Bell size={20} />, label: "Smart Notifications" },
                    { icon: <Heart size={20} />, label: "Digital Inheritance" },
                  ].map((w, i) => (
                    <div
                      className="lp-why-item"
                      key={i}
                      data-aos="fade-up"
                      data-aos-delay={i * 60}
                    >
                      <IconCircle>{w.icon}</IconCircle>
                      <span>{w.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ============ MILITARY GRADE SECURITY ============ */}
            <section className="lp-section lp-security-section">
              <div className="lp-container lp-security-grid">
                <div className="lp-shield-emblem" data-aos="zoom-in">
                  <div className="lp-glow"></div>
                  <img
                    src="/img/shield-e.png"
                    alt="I-Chest security shield"
                    className="lp-shield-img"
                  />
                </div>
                <div className="lp-security-copy" data-aos="fade-up">
                  <h4 style={{ color: "#cfdcef" }}>Military-Grade Security</h4>
                  <p>
                    We use advanced security technologies and best practices to
                    keep your legacy safe—today and always.
                  </p>
                  <ul className="lp-sec-list">
                    <li>
                      <CheckCircle2 size={15} />
                      AES-256 Encryption (At Rest & In Transit)
                    </li>
                    <li>
                      <CheckCircle2 size={15} />
                      TLS 1.3 Secure Communication
                    </li>
                    <li>
                      <CheckCircle2 size={15} />
                      Zero Trust Security Architecture
                    </li>
                    <li>
                      <CheckCircle2 size={15} />
                      Multi-Factor Authentication (MFA)
                    </li>
                    <li>
                      <CheckCircle2 size={15} />
                      Immutable Audit Logs
                    </li>
                    <li>
                      <CheckCircle2 size={15} />
                      Regular Security Testing
                    </li>
                    <li>
                      <CheckCircle2 size={15} />
                      Secure Cloud Infrastructure
                    </li>
                    <li>
                      <CheckCircle2 size={15} />
                      Disaster Recovery & Backups
                    </li>
                  </ul>
                </div>
                <div className="lp-sec-stats">
                  <div
                    className="lp-sec-stat"
                    data-aos="fade-up"
                    data-aos-delay="0"
                  >
                    <IconCircle>
                      <Lock size={16} />
                    </IconCircle>
                    <div className="lp-num">100%</div>
                    <div className="lp-lbl">Encrypted</div>
                  </div>
                  <div
                    className="lp-sec-stat"
                    data-aos="fade-up"
                    data-aos-delay="60"
                  >
                    <IconCircle>
                      <KeyRound size={16} />
                    </IconCircle>
                    <div className="lp-num">256-bit</div>
                    <div className="lp-lbl">AES Encryption</div>
                  </div>
                  <div
                    className="lp-sec-stat"
                    data-aos="fade-up"
                    data-aos-delay="120"
                  >
                    <IconCircle>
                      <Eye size={16} />
                    </IconCircle>
                    <div className="lp-num">24/7</div>
                    <div className="lp-lbl">Monitoring</div>
                  </div>
                  <div
                    className="lp-sec-stat"
                    data-aos="fade-up"
                    data-aos-delay="180"
                  >
                    <IconCircle>
                      <Activity size={16} />
                    </IconCircle>
                    <div className="lp-num">99.99%</div>
                    <div className="lp-lbl">Uptime SLA</div>
                  </div>
                </div>
              </div>
            </section>

            {/* ============ TESTIMONIALS ============ */}
            <section className="lp-section lp-testimonials">
              <div className="lp-container">
                <h3 data-aos="fade-up">
                  Trusted by Professionals Who Protect Legacies
                </h3>
                <div className="lp-testi-grid">
                  {[
                    {
                      quote:
                        "I-Chest brings clarity, security, and peace of mind to every estate plan I create for my clients.",
                      initial: "M",
                      name: "Michael R.",
                      role: "Estate Planning Attorney",
                    },
                    {
                      quote:
                        "A must-have platform for high-net-worth individuals and families. Secure, intuitive, and incredibly well built.",
                      initial: "S",
                      name: "Sarah K.",
                      role: "Financial Advisor",
                    },
                    {
                      quote:
                        "My clients love the simplicity and security of I-Chest. It's the future of legacy management.",
                      initial: "D",
                      name: "David L.",
                      role: "Family Office Manager",
                    },
                  ].map((t, i) => (
                    <div
                      className="lp-testi-card"
                      key={i}
                      data-aos="fade-up"
                      data-aos-delay={i * 80}
                    >
                      <div className="lp-stars">★★★★★</div>
                      <p className="lp-quote">"{t.quote}"</p>
                      <div className="lp-avatar">{t.initial}</div>
                      <div className="lp-name">{t.name}</div>
                      <div className="lp-role">{t.role}</div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ============ CTA BANNER ============ */}
            <section className="lp-section lp-cta-banner">
              <div
                className="lp-container lp-cta-banner-grid"
                data-aos="fade-up"
              >
                <div>
                  <h3 style={{ color: "#cfdcef" }}>
                    Protect Your Legacy Today
                  </h3>
                  <p>
                    The most valuable thing you leave behind isn't your wealth.
                    It's certainty. Create your secure digital legacy with
                    I-Chest.
                  </p>
                  <div
                    className="lp-cta-banner-actions"
                    style={{ marginTop: "20px" }}
                  >
                    <button
                      className="lp-btn lp-btn-primary"
                      onClick={toggleSignin}
                    >
                      Start Free — Create Vault
                    </button>
                    <Link
                      to="/contact-us"
                      className="lp-btn lp-btn-outline-light"
                    >
                      Talk to an Expert
                    </Link>
                  </div>
                </div>
                <img
                  src="/img/shield-h.png"
                  alt="Hands holding a secure digital shield"
                  className="lp-cta-banner-img"
                />
              </div>
            </section>

            {/* ============ FOOTER ============ */}
            <footer className="lp-footer">
              <div className="lp-container">
                <div className="lp-footer-top">
                  <div className="lp-footer-brand">
                    <a href="#header" className="lp-brand">
                      <span
                        className="lp-brand-mark"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src="/img/i-chestLogo.png" alt="I-Chest logo" />
                      </span>
                      <span className="lp-brand-text">
                        <span className="lp-brand-title">I-Chest</span>
                        <span className="lp-brand-sub">
                          Secure Your Legacy. Empower the Future.
                        </span>
                      </span>
                    </a>
                    <div className="lp-footer-social">
                      <a href="#" aria-label="LinkedIn">
                        <Linkedin size={14} color="#cfdcf4" />
                      </a>
                      <a href="#" aria-label="Twitter">
                        <Twitter size={14} color="#cfdcf4" />
                      </a>
                      <a href="#" aria-label="Facebook">
                        <Facebook size={14} color="#cfdcf4" />
                      </a>
                      <a href="#" aria-label="YouTube">
                        <Youtube size={14} color="#cfdcf4" />
                      </a>
                    </div>
                  </div>

                  <div className="lp-footer-col">
                    <h6>Product</h6>
                    <ul>
                      <li>
                        <a href="#features">Features</a>
                      </li>
                      <li>
                        <a href="#how-it-works">How It Works</a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          Security
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          Pricing
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="lp-footer-col">
                    <h6>Solutions</h6>
                    <ul>
                      <li>
                        <a href="#" onClick={toggleSignin}>
                          For Individuals
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={toggleSignin}>
                          For Families
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={toggleSignin}>
                          For Advisors
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={toggleSignin}>
                          For Businesses
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="lp-footer-col">
                    <h6>Resources</h6>
                    <ul>
                      <li>
                        <Link to="/contact-us">Help Center</Link>
                      </li>
                      <li>
                        <a href="#header">Guides</a>
                      </li>
                      <li>
                        <a href="#header">FAQ</a>
                      </li>
                      <li>
                        <Link to="/contact-us">Blog</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="lp-footer-col">
                    <h6>Company</h6>
                    <ul>
                      <li>
                        <a href="#header">About Us</a>
                      </li>
                      <li>
                        <Link to="/contact-us">Careers</Link>
                      </li>
                      <li>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/employee">Employee Portal</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="lp-footer-col">
                    <h6>Legal</h6>
                    <ul>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          Privacy Policy
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          Terms &amp; Conditions
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          Cookie Policy
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          Data Processing (DPA)
                        </a>
                      </li>
                    </ul>
                    <div className="lp-footer-badges">
                      <div className="lp-fbadge">
                        <IconCircle>
                          <ShieldCheck size={12} />
                        </IconCircle>
                        GDPR Ready
                      </div>
                      <div className="lp-fbadge">
                        <IconCircle>
                          <ShieldCheck size={12} />
                        </IconCircle>
                        CCPA Compliant
                      </div>
                      <div className="lp-fbadge">
                        <IconCircle>
                          <Lock size={12} />
                        </IconCircle>
                        SOC 2 Type II
                      </div>
                      <div className="lp-fbadge">
                        <IconCircle>
                          <CheckCircle2 size={12} />
                        </IconCircle>
                        ISO 27001 (In Progress)
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lp-footer-bottom">
                  <span>© 2026 I-Chest. All rights reserved.</span>
                  <div className="lp-footer-bottom-links">
                    <a href="#" onClick={(e) => e.preventDefault()}>
                      Status Page
                    </a>
                    <Link to="/contact-us">Support</Link>
                    <a href="#" onClick={(e) => e.preventDefault()}>
                      English ▾
                    </a>
                  </div>
                </div>
              </div>
            </footer>
            <Version />
          </div>
        )}

        {modalData && (
          <div className="modal" onClick={closeModal}>
            <div
              className="card_modal_content"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="close" onClick={closeModal}>
                &times;
              </span>
              <div id="modal-details">
                <div className="card_design">
                  <div className="card_image">
                    <img
                      className="card_profile_image"
                      src={`./img/patners-image/${modalData.image}`}
                      alt={modalData.title}
                    />
                  </div>
                  <div className="card_content">
                    <h2>{modalData.title}</h2>
                    <p>
                      <strong>Role:</strong> {modalData.role}
                    </p>
                  </div>
                </div>
                <div className="details_card">
                  <p>{modalData.details1}</p>
                  <p className="second_paragraph">{modalData.details2}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Home;